<template>
  <div class="album_page">
    <div class="top_banner">
      <img class="top_logo" src="../../assets/tfsharelogo.png" alt="">
      <div class="middel-info">
        <div>铁粉生活</div>
        <div class="s_text">湖南广电旗下唯一本地生活服务APP</div>
      </div>
      <div id="btn_open">打开APP</div>
    </div>
    <div style="margin-top: 55px;" v-if="!isEmpty">
      <div class="top">
        <div class="album_title">
          <div class="album_img" :style="styleObj"></div>
          <div class="c_name">
            <div class="name">{{info.name}}</div>
            <div class="sub_name">{{info.subName}}</div>
          </div>
        </div>
        <div class="album_description">
          <div class="desc_title">内容简介</div>
          <div :class="showAllContent ? '' : 'description'">{{info.description}}</div>
          <div class="more" @click="showAllContent=!showAllContent">{{ showAllContent ? '收起' : '展开' }}简介<Icon :type="showAllContent ? 'ios-arrow-up' : 'ios-arrow-down'" /></div>
        </div>
      </div>
      <div class="list_container">
        <Tabs value="name1" class="tab_container">
          <Tab-pane label="音频" name="name1">
            <div class="tab_panel">
              <div class="audio_item" v-for="(item, index) in audioList" :key="index" @click="gotoAudio(item)">
                <div class="no">{{index + 1}}</div>
                <div>
                  <div class="item_name">{{item.name}}</div>
                  <div class="num_info">
                    <span><img src="../../assets/time.png" alt="">{{item.mediaLength | minFormat}}</span>
                    <span style="margin-left: 20px;"><img src="../../assets/play.png" alt="">{{item.pv | numFormat}}</span>
                  </div>
                </div>
              </div>
            </div>
          </Tab-pane>
          <Tab-pane label="视频" name="name2">
            <div class="tab_panel">
              <div class="audio_item" v-for="(item, index) in videoList" :key="index" @click="gotoVideo(item)">
                <div class="image" :style="{backgroundImage: 'url(' + item.imageUrl + ')', backgroundSize: 'cover', backgroundPosition: 'center center'}">
                </div>
                <div>
                  <div class="video_name">{{item.name}}</div>
                  <div class="num_info">
                    <span><img src="../../assets/time.png" alt="">{{item.mediaLength | minFormat}}</span>
                    <span style="margin-left: 20px;"><img src="../../assets/play.png" alt="">{{item.pv | numFormat}}</span>
                  </div>
                </div>
              </div>
            </div>
          </Tab-pane>
          <Tab-pane label="资讯" name="name3">
            <div class="tab_panel">
              <div class="audio_item" v-for="(item, index) in picList" :key="index" @click="gotoArticle(item)">
                <div>
                  <div class="item_name">{{item.name}}</div>
                  <div class="num_info">
                    <span><img src="../../assets/view.png" alt="">{{item.pv | numFormat}}</span>
                    <div style="float: right">{{item.createTime | dateFormat}}</div>
                  </div>
                </div>
                <div class="image t_r">
                  <img :src="item.imageUrl" alt="">
                </div>
              </div>
            </div>
          </Tab-pane>
        </Tabs>
        <Spin fix size="large" v-if="!loading && mediaLoading"></Spin>
      </div>
    </div>
    <div class="empty_container" :style="{'height': contentHeight + 'px'}" v-else>专辑已被删除</div>
    <Spin fix size="large" v-if="loading"></Spin>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "album",
  data() {
    return {
      loading: true,
      mediaLoading: true,
      showAllContent: false,
      isEmpty: false,
      albumInfoId: '',
      styleObj: {},
      info: {},
      audioList: [],
      videoList: [],
      picList: [],
      contentHeight: document.documentElement.clientHeight
    }
  },
  filters: {
    minFormat: function (value) {
      if (!value) {
        return value
      }
      let d = moment.duration(value, 'seconds')
      let seconds = d.seconds() < 10 ? ('0' + d.seconds()) : d.seconds()
      return d.minutes() + ':' + seconds
    },
    timeFormat: function (value) {
      if (!value) return ''
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    dateFormat: function (value) {
      if (!value) return ''
      return moment(value).format('YYYY-MM-DD')
    },
    numFormat: function (value) {
      if (value > 10000) {
        return (value / 10000).toFixed(1) + '万'
      }
      return value
    }
  },
  mounted() {
    let param = this.$route.query
    this.albumInfoId = param.id

    // linkType(3:专辑)
    var data = XInstall.parseUrlParams();
    new XInstall({
      appKey : "mq81ipn",
      buttonId: [
        { idName: 'btn_open', params: {linkType: 3, linkId: param.id} }
      ]
    }, data);

    this.getAlbumInfo()
    this.getPlayList(0)
    this.getPlayList(1)
    this.getPlayList(2)
  },
  methods: {
    getAlbumInfo() {
      let that = this
      that.loading = true
      this.$http.get('/album/open/getAlbumInfo', {
        albumInfoId: this.albumInfoId
      }, function (data) {
        that.info = data.data
        that.styleObj = {
          backgroundImage: 'url(' + that.info.imageUrl + ')',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center'
        }
        that.isEmpty = false
        that.loading = false
      }, function () {
        that.isEmpty = true
        that.loading = false
      })
    },
    getPlayList(mediaType) {
      let that = this
      that.mediaLoading = true
      this.$http.get('/albumDetail/open/getPlayList', {
        albumId: this.albumInfoId,
        mediaType: mediaType
      }, function (data) {
        if (mediaType == 0) {
          that.audioList = data.data
        } else if (mediaType == 1) {
          that.videoList = data.data
        } else if (mediaType == 2) {
          that.picList = data.data
        }
        that.mediaLoading = false
      }, function () {
        that.mediaLoading = false
      })
    },
    gotoAudio(item) {
      this.$router.push({
        path: '/audio',
        query: {
          id: item.id
        }
      })
    },
    gotoVideo(item) {
      this.$router.push({
        path: '/video',
        query: {
          id: item.id
        }
      })
    },
    gotoArticle(item) {
      this.$router.push({
        path: '/article',
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>

<style scoped>
.album_page {
  position: relative;
}

.top_banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  background: rgb(255, 255, 255);
  padding: 6px;
  color: #000;
  border-bottom: 1px solid #eee;
}
.top_logo {
  width: 40px;
  border-radius: 6px;
}
.middel-info {
  flex: 1;
  margin-left: 6px;
  font-size: 16px;
}
.s_text {
  font-size: 12px;
  color: rgba(153,153,153,1);
}
#btn_open {
  background-color: #3C74F2;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 20px;
  color: #fff;
}
.top {
  background: url("../../assets/album.png") no-repeat center center;
  background-size: cover;
  color: #fff;
  padding-bottom: 30px;
}
.album_title {
  display: flex;
  padding: 10px;
  align-items: center;
}
.album_img {
  width: 70px;
  height: 84px;
}
.album_description {
  background-color: rgba(0, 0, 0, 0.3);
  margin: 0 10px;
  padding: 10px;
  overflow: hidden;
  font-size: 13px;
  border-radius: 20px;
}
.desc_title {
  font-size: 14px;
}
.description {
  height: 60px;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.more {
  border: 1px solid;
  border-radius: 16px;
  font-size: 12px;
  margin-top: 5px;
  width: 86px;
  text-align: center;
  float: right;
}
.image {
  width: 80px;
  height: 100px;
}
.c_name {
  padding-left: 10px;
}
.name {
  font-size: 18px;
}
.sub_name {
  font-size: 13px;
}
.list_container {
  margin-top: -20px;
  background-color: #fff;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  position: relative;
}
.tab_container >>> .ivu-tabs-bar {
  border-bottom: none;
}
.tab_container >>> .ivu-tabs-nav-scroll {
  text-align: center;
}
.tab_container >>> .ivu-tabs-nav {
  float: initial;
}
.tab_container >>> .ivu-tabs-ink-bar {
  display: none;
}
.tab_container >>> .ivu-tabs-nav .ivu-tabs-tab-active {
  font-size: 16px;
  font-weight: bold;
  color: #F29A3C;
  border-bottom: 5px solid #F29A3C;
}
.tab_container >>> .ivu-tabs-nav-container:focus .ivu-tabs-tab-focused {
  border-color: #F29A3C!important;
}
.tab_panel {
  padding: 10px;
}
.audio_item {
  display: flex;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  align-items: center;
}
.audio_item:last-child {
  margin-bottom: 0;
  border-bottom: none;
}
.no {
  width: 30px;
  flex-shrink: 0;
}
.item_name {
  font-size: 15px;
}
.num_info {
  font-size: 13px;
  color: #666;
  margin-top: 10px;
}
.num_info img {
  height: 10px;
  margin-right: 5px;
}
.tab_panel .image {
  width: 86px;
  height: 102px;
  flex-shrink: 0;
  border-radius: 10px;
  margin-right: 10px;
}
.tab_panel .image.t_r {
  text-align: right;
}
.tab_panel .image img {
  width: 60px;
  height: 60px;
}
.video_name {
  color: #EF7409;
  font-size: 15px;
}
.empty_container {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/album.vue